const namespaced = true

const state = {}

const actions = {

    async getAllPersonsWithoutPosterPresenters({dispatch}) {
        let persons = [];
        let data = await dispatch('database/getMultiple', ['person_roles', 'persons'], {root: true});

        for (let i = 0; i < data['persons'].length; i++) {
            let person = data['persons'][i];
            person.roles = data['person_roles'].filter(p => p.person_id == person.id);
            if (person.roles.length == 1 && person.roles[0].function != 'Poster Presenter') {
                persons.push(person);
            }
            if (person.roles.length > 1) {

                for (let k = 0; k < person.roles.length; k++) {
                    let role = person.roles[k];
                    if (role.function != 'Poster Presenter') {
                        persons.push(person);
                        break;
                    }
                }
            }
        }
        return persons;
    },

    async getAllPersonsOnlyPosterPresenters({dispatch}) {
        let persons = [];
        let data = await dispatch('database/getMultiple', ['person_roles', 'persons'], {root: true});
        for (let i = 0; i < data['persons'].length; i++) {
            let person = data['persons'][i];
            person.roles = data['person_roles'].filter(p => p.person_id == person.id && p.function == 'Poster Presenter');
            if (person.roles.length > 0) {
                persons.push(person);
            }
        }
        return persons;
    },

    async getAllPersons({dispatch}) {
        return await dispatch('database/getItems', {table: 'persons'}, {root: true})
    },
    async getPersonById({dispatch}, id) {
        return await dispatch('database/getItem', {table: 'persons', id: id}, {root: true})
    },
    async getPersonsById({dispatch}, ids) {
        let persons = await dispatch('database/getItems', {table: 'persons'}, {root: true});
        let personsToReturn = [];

        personsToReturn = persons.filter(pers => ids.indexOf(pers.id) != -1);
        return personsToReturn
    },
    async getAllFaculty({dispatch}) {
        const start = Date.now();

        let persons = [];
        let data = await dispatch('database/getMultiple', ['person_roles', 'persons', 'session_sessiontype_links', 'sessiontypes', 'session_presentation_links'], {root: true});

        let scientificTypes = data['sessiontypes'].filter(type => type.category == true);
        let scientificTypeLinks = [];
        let linkedPresentations = [];
        for (let l = 0; l < scientificTypes.length; l++) {
            let type = scientificTypes[l];
            let links = data['session_sessiontype_links'].filter(link => link.sessiontype_id == type.id)
            scientificTypeLinks = scientificTypeLinks.concat(links);
        }
        let sessions = scientificTypeLinks.reduce((t, {session_id}) => {
            var temp = t.find(o => session_id === o.session_id);
            if (!temp) {
                t.push(temp = session_id);
            }
            return t;
        }, []);
        const endSessions = Date.now();
        console.log(`Execution time sessions: ${endSessions - start} ms`, sessions.length);


        for (let m = 0; m < sessions.length; m++) {
            let session = sessions[m];
            let presentations = data['session_presentation_links'].filter(link => link.session_id == session)
            linkedPresentations = linkedPresentations.concat(presentations);
        }

        let presentations = linkedPresentations.reduce((t, {presentation_id}) => {
            var temp = t.find(o => presentation_id === o.presentation_id);
            if (!temp) {
                t.push(temp = presentation_id);
            }
            return t;
        }, []);
        const endPresentations = Date.now();
        console.log(`Execution time presentations: ${endPresentations - start} ms`, presentations.length);

        let roles = data['person_roles'].filter(p => (sessions.indexOf(p.session_id) != -1 || presentations.indexOf(p.presentation_id) != -1));
        console.log('TYPE link roles', roles)

        const endRoles = Date.now();
        console.log(`Execution time roles: ${endRoles - start} ms`, roles.length);


        let personsToAdd = roles.reduce((t, {person_id}) => {
            var temp = t.find(o => person_id === o.person_id);
            if (!temp) {
                if (t.indexOf(person_id) == -1) {
                    t.push(temp = person_id);
                }
            }
            return t;
        }, []);
        const endPersonsToAdd = Date.now();
        console.log(`Execution time endPersonsToAdd: ${endPersonsToAdd - start} ms`, personsToAdd.length);
        persons = data['persons'].filter(pers => personsToAdd.indexOf(pers.id) != -1)

        const endPersonsFilter = Date.now();
        console.log(`Execution time endPersonsFilter: ${endPersonsFilter - start} ms`, persons.length);

        return persons;
    },

    //NEW FUNCTION TO FILTER FOR EITHER WORKSHOP OR NORMAL PROGRAMME PERSONS
    async getAllPersonsByPart({dispatch}, part) {
        let persons = [];
        let data = await dispatch('database/getMultiple', ['person_roles', 'persons'], {root: true});

        if (part === 'Faculty') {
            // Faculty: persons who have at least one role that is NOT "Poster Presenter"
            for (let i = 0; i < data['persons'].length; i++) {
                let person = data['persons'][i];
                let allRoles = data['person_roles'].filter(p => p.person_id == person.id);
                let nonPosterRoles = allRoles.filter(p => p.function !== 'Poster Presenter');
                if (nonPosterRoles.length > 0) {
                    person.roles = allRoles.map(role => role.function);
                    persons.push(person);
                }
            }
        } else if (part === 'Poster Presenter') {
            // Poster Presenter: persons whose ONLY role is "Poster Presenter"
            for (let i = 0; i < data['persons'].length; i++) {
                let person = data['persons'][i];
                let allRoles = data['person_roles'].filter(p => p.person_id == person.id);
                if (allRoles.length > 0 && allRoles.every(p => p.function === 'Poster Presenter')) {
                    person.roles = allRoles.map(role => role.function);
                    persons.push(person);
                }
            }
        } else if (part === 'Workshop') {
            for (let i = 0; i < data['persons'].length; i++) {
                let person = data['persons'][i];
                person.roles = data['person_roles'].filter(p => p.person_id == person.id && p.function.indexOf(part) == 0).map(role => role.function);
                if (person.roles.length > 0) {
                    persons.push(person);
                }
            }
        } else {
            for (let i = 0; i < data['persons'].length; i++) {
                let person = data['persons'][i];
                person.roles = data['person_roles'].filter(p => p.person_id == person.id).map(role => role.function);
                if (person.roles.length > 0) {
                    persons.push(person);
                }
            }
        }
        return persons;
    },

    async getAllRolesByPart({dispatch}, part) {
        let data = await dispatch('database/getMultiple', ['person_roles'], {root: true});

        // Group roles by person_id
        let rolesByPerson = {};
        for (let i = 0; i < data['person_roles'].length; i++) {
            let role = data['person_roles'][i];
            if (!rolesByPerson[role.person_id]) {
                rolesByPerson[role.person_id] = new Set();
            }
            rolesByPerson[role.person_id].add(role.function);
        }

        let hasFaculty = false;
        let hasPosterOnly = false;

        for (let personId in rolesByPerson) {
            let roles = rolesByPerson[personId];
            if (roles.size === 1 && roles.has('Poster Presenter')) {
                hasPosterOnly = true;
            } else {
                hasFaculty = true;
            }
            if (hasFaculty && hasPosterOnly) break;
        }

        let result = [];
        if (hasFaculty) {
            result.push({role: 'Faculty', order: 1});
        }
        if (hasPosterOnly) {
            result.push({role: 'Poster Presenter', order: 2});
        }
        return result;
    },


    async getAllPersonsByRole2({dispatch}, role) {
        let persons = [];
        let data = await dispatch('database/getMultiple', ['person_roles', 'persons'], {root: true});

        if (role === 'Faculty') {
            // Faculty: persons who have at least one role that is NOT "Poster Presenter"
            for (let i = 0; i < data['persons'].length; i++) {
                let person = data['persons'][i];
                let allRoles = data['person_roles'].filter(p => p.person_id == person.id);
                let nonPosterRoles = allRoles.filter(p => p.function !== 'Poster Presenter');
                if (nonPosterRoles.length > 0) {
                    person.roles = allRoles;
                    persons.push(person);
                }
            }
        } else if (role === 'Poster Presenter') {
            // Poster Presenter: persons whose ONLY role is "Poster Presenter"
            for (let i = 0; i < data['persons'].length; i++) {
                let person = data['persons'][i];
                let allRoles = data['person_roles'].filter(p => p.person_id == person.id);
                if (allRoles.length > 0 && allRoles.every(p => p.function === 'Poster Presenter')) {
                    person.roles = allRoles;
                    persons.push(person);
                }
            }
        } else {
            for (let i = 0; i < data['persons'].length; i++) {
                let person = data['persons'][i];
                person.roles = data['person_roles'].filter(p => p.person_id == person.id && p.function == role);
                if (person.roles.length > 0) {
                    persons.push(person);
                }
            }
        }
        return persons;
    }
    ,
    async getAllPersonsByRole({dispatch}, role) {
        let persons = [];
        let data = await dispatch('database/getMultiple', ['person_roles', 'persons'], {root: true});
        for (let i = 0; i < data['persons'].length; i++) {
            let person = data['persons'][i];
            if (person.vip_status.find(vs => vs == role)) {
                persons.push(person)
            }
        }
        return persons;
    }
    ,


    async getPresentations({dispatch}, id) {
        let sessions = [];
        let presentations = [];
        let data = await dispatch('database/getMultiple', ['person_roles', 'sessions', 'sessiontypes', 'session_sessiontype_links', 'locations', 'session_location_links', 'presentations', 'session_presentation_links', 'persons'], {root: true});

        for (let h = 0; h < data['person_roles'].length; h++) {
            let person_role = data['person_roles'][h];
            if (person_role.person_id == id) {

                let linkedPresentations = data['session_presentation_links'].filter(lp => lp.presentation_id == person_role.presentation_id);

                for (let lp = 0; lp < linkedPresentations.length; lp++) {
                    let lpres = linkedPresentations[lp];
                    lpres.speakers = [];
                    let session = data['sessions'].find(sess => sess.id == lpres.session_id);
                    lpres.color = session.color;
                    lpres.session = session;
                    lpres.sess_id = session.id;
                    let presentationsTmp = data['presentations'].find(presentation => presentation.id == lpres.presentation_id);
                    if (presentationsTmp) {
                        lpres.pres_id = presentationsTmp.id;
                        lpres.title = presentationsTmp.title;
                        let personsTmp = data['persons'].filter(person => person.id == person_role.person_id);
                        personsTmp.forEach(person => {
                            let _personToAdd = JSON.parse(JSON.stringify(person));
                            _personToAdd.coi = person_role.person_roles ? person_role.person_roles : null
                            lpres.speakers.push(_personToAdd);
                        })
                        if (JSON.stringify(presentations).indexOf(lpres.id) == -1) {
                            //lpres['coi'] = person_role.person_roles ? person_role.person_roles : null

                            presentations.push(lpres);
                        }
                    }

                }
            }
        }
        return presentations;

    }
    ,

    async getSessions({dispatch}, id) {
        let sessions = [];
        let data = await dispatch('database/getMultiple', ['person_roles', 'sessions', 'sessiontypes', 'session_sessiontype_links', 'locations', 'session_location_links', 'presentations', 'session_presentation_links', 'persons'], {root: true});
        for (let h = 0; h < data['person_roles'].length; h++) {
            let person_roles = data['person_roles'][h];
            if (person_roles.person_id == id) {

                //session-block
                let sessionsTmp = data['sessions'].filter(session => session.id == person_roles.session_id);
                sessionsTmp.forEach(session => {

                    let sesstype_links = data['session_sessiontype_links'].filter(sesstypelink => sesstypelink.session_id == session.id);
                    sesstype_links.forEach(typelink => {

                        let type = data['sessiontypes'].filter(type => type.id == typelink.sessiontype_id)[0];
                        if (type) {

                            session.session_type_text = type.name;

                            session.session_type_order = type.order;
                            session.is_scientific = type.scientific;
                        }
                    })

                    let sessloc_link = data['session_location_links'].filter(sessloc_link => sessloc_link.session_id == session.id)[0];
                    let location = data['locations'].filter(location => location.id == sessloc_link.location_id)[0];
                    session.location = location;
                    session.location_order = location ? location.order : 0;
                    session.chair = []
                    session.speakers = [];
                    /*let sess_pres_links = data['session_presentation_links'].filter(sess_pres_link => sess_pres_link.session_id == session.id);
                    sess_pres_links.forEach(sess_pres_link => {
                        let sessionroles = data['person_roles'].filter(sessrole => sessrole.session_id == session.id)
                        let presroles = data['person_roles'].filter(presrole => presrole.presentation_id == sess_pres_link.presentation_id)
                        sessionroles.forEach(role => {
                            let person = data['persons'].filter(person => person.id == role.person_id)[0];
                            if (person) {
                                person.function = role.function;
                                if (JSON.stringify(session.chair).indexOf(person.id) == -1) {
                                    session.chair.push(person);
                                }
                            }
                        })
                        presroles.forEach(role => {
                            let person = data['persons'].filter(person => person.id == role.person_id)[0];
                            if (person) {
                                person.function = role.function;
                                if (JSON.stringify(session.speakers).indexOf(person.id) == -1 && JSON.stringify(session.chair).indexOf(person.id) == -1) {
                                    session.speakers.push(person);
                                }
                            }
                        })
                    })*/
                    if (JSON.stringify(sessions).indexOf(session.id) == -1) {
                        session['coi'] = person_roles.person_roles ? person_roles.person_roles : null
                        sessions.push(session);
                    }

                });
                let presentationsTmp = data['presentations'].filter(pres => pres.id == person_roles.presentation_id);

                presentationsTmp.forEach(pres => {
                    let sessPreslinks = data['session_presentation_links'].filter(spl => spl.presentation_id == pres.id);
                    sessPreslinks.forEach(spl => {
                        let sessionsTmp = data['sessions'].filter(session => session.id == spl.session_id);
                        sessionsTmp.forEach(session => {

                            let sesstype_links = data['session_sessiontype_links'].filter(sesstypelink => sesstypelink.session_id == session.id);
                            sesstype_links.forEach(typelink => {
                                let type = data['sessiontypes'].filter(type => type.id == typelink.sessiontype_id)[0];
                                if (type) {

                                    session.session_type_text = type.name;

                                    session.session_type_order = type.order;
                                    session.is_scientific = type.scientific;
                                }
                            })

                            let sessloc_link = data['session_location_links'].filter(sessloc_link => sessloc_link.session_id == session.id)[0];
                            let location = data['locations'].filter(location => location.id == sessloc_link.location_id)[0];
                            session.location = location;
                            session.location_order = location ? location.order : 0;
                            session.chair = []
                            session.speakers = [];
                            /* let sess_pres_links = data['session_presentation_links'].filter(sess_pres_link => sess_pres_link.session_id == session.id);
                             sess_pres_links.forEach(sess_pres_link => {
                                 let sessionroles = data['person_roles'].filter(sessrole => sessrole.session_id == session.id)
                                 let presroles = data['person_roles'].filter(presrole => presrole.presentation_id == sess_pres_link.presentation_id)
                                 sessionroles.forEach(role => {
                                     let person = data['persons'].filter(person => person.id == role.person_id)[0];
                                     if (person) {
                                         person.function = role.function;
                                         if (JSON.stringify(session.chair).indexOf(person.id) == -1) {
                                             session.chair.push(person);
                                         }
                                     }
                                 })
                                 presroles.forEach(role => {
                                     let person = data['persons'].filter(person => person.id == role.person_id)[0];
                                     if (person) {
                                         person.function = role.function;
                                         if (JSON.stringify(session.speakers).indexOf(person.id) == -1 && JSON.stringify(session.chair).indexOf(person.id) == -1) {
                                             session.speakers.push(person);
                                         }
                                     }
                                 })
                             })*/
                            if (JSON.stringify(sessions).indexOf(session.id) == -1) {
                                sessions.push(session);
                            }

                        });
                    })
                })
            }
        }
        return sessions;
    },

    async getAllPersonsByFilter({dispatch}, role) {
        let data = await dispatch('database/getMultiple', ['person_roles', 'persons'], {root: true});
        console.log('role', role)
        let persons = data['persons'].filter(p => p.vip_status?.id == role);
        return persons;
    }


}
const mutations = {}
const getters = {}

export const persons = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
